import Layout from "@/layouts/layout";
import PageHeading from "@/components/layout/PageHeading";
import Card from "@/components/ui/Card";
import Badge from "@/components/ui/Badge";
import EmptyState from "@/components/ui/EmptyState";
import { Link } from "@inertiajs/react";
import LockedNotice from "@/components/guides/LockedNotice";
import {
  AUDIENCE_LABELS,
  type Guide,
  type GuideAudience,
} from "@/interfaces/guide";

const ORDER: GuideAudience[] = ["organizers", "participants", "everyone"];

export default function GuidesIndex({
  guides,
  locked_for_others,
}: {
  guides: Guide[];
  audiences: GuideAudience[];
  locked_for_others: boolean;
}) {
  const groups = ORDER.map((audience) => ({
    audience,
    items: guides.filter((g) => g.audience === audience),
  })).filter((group) => group.items.length > 0);

  return (
    <Layout>
      <div className="flex flex-col gap-8">
        <LockedNotice locked={locked_for_others} />

        <PageHeading
          title="Guides"
          subtitle="Everything you need to run a Boba Bash, or to show up to one."
        />

        {guides.length === 0 ? (
          <EmptyState
            title="No guides yet"
            description="The team is still writing them. Check back soon."
          />
        ) : (
          groups.map((group) => (
            <section key={group.audience} className="flex flex-col gap-4">
              <h2 className="font-display text-heading text-ink font-bold">
                {AUDIENCE_LABELS[group.audience]}
              </h2>

              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {group.items.map((guide) => (
                  <Link key={guide.id} href={`/guides/${guide.slug}`}>
                    <Card interactive>
                      <h3 className="font-display text-subheading text-ink leading-tight font-bold">
                        {guide.title}
                      </h3>
                      {guide.summary && (
                        <p className="text-body text-ink-muted mt-2 line-clamp-3">
                          {guide.summary}
                        </p>
                      )}
                      <div className="mt-auto pt-4">
                        <Badge tone="neutral">Read</Badge>
                      </div>
                    </Card>
                  </Link>
                ))}
              </div>
            </section>
          ))
        )}
      </div>
    </Layout>
  );
}
